import { Position } from '@keepeek/commons';
import { getVisualAlertsData } from './getVisualAlertsData.js';

/**
 *
 * @param visualAlertsConf Visual alerts configuration from Admin ReFront
 * @param element media
 * @returns list of TagProps by Position (only position with tags are present in the map)
 */
function getVisualAlertsDataByPosition(visualAlertsConf, element, currentLocale) {
    if (currentLocale === void 0) { currentLocale = "fr"; }
    var tagsDataByPosition = new Map();
    for (var positionAsString in Position) {
        var position = Position[positionAsString];
        var tagsDataForCurrentPosition = getVisualAlertsData(visualAlertsConf, element, position, currentLocale);
        if (tagsDataForCurrentPosition === null || tagsDataForCurrentPosition === void 0 ? void 0 : tagsDataForCurrentPosition.length) {
            tagsDataByPosition.set(position, tagsDataForCurrentPosition);
        }
    }
    return tagsDataByPosition;
}

export { getVisualAlertsDataByPosition };
//# sourceMappingURL=getVisualAlertsDataByPosition.js.map
